import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dayOfWeekTransform',
})
export class DayOfWeekTransformPipe implements PipeTransform {
  private daysOfWeekMap: { [key: string]: string } = {
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
  };

  transform(value: string): string {
    if (!value) return 'Invalid day';
    const lowerCaseValue = value.toLowerCase();
    return this.daysOfWeekMap[lowerCaseValue] || 'Día invalido';
  }
}
